import { InvoiceStatus } from "../../models/InvoiceModel";

export class InvoiceUtils {
    public static getStatusText(status: InvoiceStatus): string {
        switch (status) {
            case InvoiceStatus.all: return "All";
            case InvoiceStatus.pending: return "Pending";
            case InvoiceStatus.processing: return "Processing";
            case InvoiceStatus.itemsReady: return "Ready";
            case InvoiceStatus.confirmed: return "Confirmed";
            case InvoiceStatus.readyForDelivery: return "Ready For Delivery";
            case InvoiceStatus.outForDelivery: return "Out For Delivery";
            case InvoiceStatus.completed: return "Completed";
        }

        return "";
    }
}